import { useTranslation } from 'react-i18next';

const DataFaqs = () => {
    const { t } = useTranslation();

    const dataFaqs = [
        {
            id: 1,
            title: t('purchase_notice'),
            text: `
                <div class="item-content font-weight-medium my-5">
                <p class="content-title font-weight-bold">1. ${t('necessary_information')}</p><br>
                <div class="ml-4">
                    <p class="text-orange">${t('ea_fc_email')}</p>
                    <p class="text-orange">${t('ea_fc_password')}</p>
                    <p class="text-orange">${t('backup_codes')}
                 
                     </p>
                </div>
                </div>
                <div class="item-content my-5">
                    <p class="content-title font-weight-bold">2. ${t('things_to_know_before_purchase')}</p><br>
                    <div class="ml-4">
                        <div class="text my-3"><span class="num">1 - </span><strong class="font-weight-medium">${t('transfer_market')}:</strong> ${t('transfer_market_info')}</div>
                        <div class="text my-3"><span class="num">2 - </span><strong class="font-weight-medium">${t('coin_requirement')}:</strong> ${t('coin_requirement_info')}</div>
                        <div class="text my-3"><span class="num">3 - </span><strong class="font-weight-medium">${t('stay_logged_out')}:</strong> ${t('stay_logged_out_info')}</div>
                         </div>
                </div>
                
                <div class="item-content my-5">
                    <p class="content-title font-weight-bold">3. ${t('purchase_process')}</p><br>
                    <div class="text"><span class="num ml-4">1 - </span>${t('unlock_transfer_market')}</div>
                    <div class="text"><span class="num ml-4">2 - </span>${t('choose_platform_and_amount')}</div>
                    <div class="text"><span class="num ml-4">3 - </span>${t('log_in_and_select_payment')}</div>
                    <div class="text"><span class="num ml-4">4 - </span>${t('click_get_coins')}</div>
                    <div class="text"><span class="num ml-4">5 - </span>${t('order_status_completed')}</div>
                </div>
            `,
            show: 'show'
        },
        {
            id: 2,
            title: t('buy_fc_coins'),
            text: `
                <div class="item-content" style="display: block;">
                    <p class="my-4">${t('main_currencies_info')}</p>
                    <p class="my-4"><strong>${t('fifa_coins')}</strong> ${t('fifa_coins_usage')}</p>
                    <p class="my-4">${t('player_packs_info')}</p>
                    <p class="my-4">${t('cosmetics_info')}</p>
                </div>
            `,
        },
        {
            id: 3,
            title: t('how_to_get_fc_coins'),
            text: `
                <div class="item-content" style="display: block;">
                   <p class="my-4">${t('ways_to_earn_coins')}</p>
                   <p class="my-4">${t('play_matches_info')}</p>
                   <p class="my-4">${t('challenge_game_modes_info')}</p>
                   <p class="my-4">${t('trading_market_info')}</p>
                   <p class="my-4">${t('buying_coins_info')}</p>
               </div>
            `,
        },
        {
            id: 4,
            title: t('reason_to_buy_fc_coins'),
            text: `
                <div class="item-content" style="display: block;">
                    <p class="my-4">${t('importance_of_coins')}</p>
                    <p class="my-4">${t('lineup_strength_info')}</p>
                    <p class="my-4">${t('getting_coins_info')}</p>
                    <p class="my-4">${t('buying_coins_recommendation')}</p>
                </div>
            `
        },
        {
            id: 5,
            title: t('where_to_buy_ea_fc_coins'),
            text: `
                <div class="item-content" style="display: block;">
                    <p class="my-4">${t('reliable_website_info')}</p>
                    <p class="my-4">${t('Masterfut_info')}</p>
                </div>
            `
        },
        {
            id: 6,
            title: t('faq'),
            text: `
                <div class="item-content my-4" style="display: block;">
                <p class="content-title font-weight-bold">${t('transfer_fc25_to_fc26')}</p>
                <div class="ml-4 mt-3">
                        <p>${t('transfer_policy_info')}</p>
                    </div>
                </div>
                <div class="item-content my-4" style="display: block;">
                <p class="content-title font-weight-bold">${t('how_Masterfut_delivers_coins')}</p>
                <div class="ml-4 mt-3">
                        <p>${t('comfort_trade_info')}</p>
                    </div>
                </div>
                <div class="item-content my-4" style="display: block;">
                <p class="content-title font-weight-bold">${t('can_fc26_coins_buy_players')}</p>
                <div class="ml-4 mt-3">
                        <p>${t('buying_coins_discouraged')}</p>
                    </div>
                </div>
                <div class="item-content my-4" style="display: block;">
                <p class="content-title font-weight-bold">${t('is_it_safe_to_buy_coins')}</p>
                <div class="ml-4 mt-3">
                        <p>${t('account_safety_info')}</p>
                        <p>${t('transaction_safety_info')}</p>
                    </div>
                </div>
            `
        },
    ];

    return dataFaqs;
};

export default DataFaqs;
